import { render } from "./updatePwa.vue?vue&type=template&id=59932e1e"
import script from "./updatePwa.vue?vue&type=script&lang=js"
export * from "./updatePwa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__